/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { Discount } from './Discount';
// @ts-ignore
import {
// @ts-ignore
    DiscountFromJSON,
// @ts-ignore
    DiscountFromJSONTyped,
// @ts-ignore
    DiscountToJSON,
} from './Discount';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { TimeWindow } from './TimeWindow';
// @ts-ignore
import {
// @ts-ignore
    TimeWindowFromJSON,
// @ts-ignore
    TimeWindowFromJSONTyped,
// @ts-ignore
    TimeWindowToJSON,
} from './TimeWindow';

/**
 * 
 * @export
 * @interface Promotion
 */
export interface Promotion {
    /**
     * 
     * @type {string}
     * @memberof Promotion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Promotion
     */
    name: string;
    /**
     * 
     * @type {TimeWindow}
     * @memberof Promotion
     */
    effectivePeriod?: TimeWindow;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof Promotion
     */
    discounts: Array<Discount>;
    /**
     * 
     * @type {string}
     * @memberof Promotion
     */
    currencyCode: string;
    /**
     * 
     * @type {Amount}
     * @memberof Promotion
     */
    minimumAmount?: Amount;
    /**
     * 
     * @type {number}
     * @memberof Promotion
     */
    minimumQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof Promotion
     */
    supplierId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Promotion
     */
    retailerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Promotion
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Promotion
     */
    productCategoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof Promotion
     */
    productListId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Promotion
     */
    skuIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Promotion
     */
    allProducts?: boolean;
    /**
     * 
     * @type {Status}
     * @memberof Promotion
     */
    status: Status;
    /**
     * 
     * @type {Date}
     * @memberof Promotion
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the Promotion interface.
 */
// @ts-ignore
export function instanceOfPromotion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "discounts" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "minimumQuantity" in value;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

// @ts-ignore
export function PromotionFromJSON(json: any): Promotion {
    return PromotionFromJSONTyped(json, false);
}

// @ts-ignore
export function PromotionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Promotion {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'effectivePeriod': !exists(json, 'effective_period') ? undefined : TimeWindowFromJSON(json['effective_period']),
        'discounts': ((json['discounts'] as Array<any>).map(DiscountFromJSON)),
        'currencyCode': json['currency_code'],
        'minimumAmount': !exists(json, 'minimum_amount') ? undefined : AmountFromJSON(json['minimum_amount']),
        'minimumQuantity': json['minimum_quantity'],
        'supplierId': json['supplier_id'],
        'retailerIds': !exists(json, 'retailer_ids') ? undefined : json['retailer_ids'],
        'storeIds': !exists(json, 'store_ids') ? undefined : json['store_ids'],
        'productCategoryId': !exists(json, 'product_category_id') ? undefined : json['product_category_id'],
        'productListId': !exists(json, 'product_list_id') ? undefined : json['product_list_id'],
        'skuIds': !exists(json, 'sku_ids') ? undefined : json['sku_ids'],
        'allProducts': !exists(json, 'all_products') ? undefined : json['all_products'],
        'status': StatusFromJSON(json['status']),
        'createdAt': (new Date(json['created_at'])),
    };
}

// @ts-ignore
export function PromotionToJSON(value?: Promotion | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'effective_period': TimeWindowToJSON(value.effectivePeriod),
        'discounts': ((value.discounts as Array<any>).map(DiscountToJSON)),
        'currency_code': value.currencyCode,
        'minimum_amount': AmountToJSON(value.minimumAmount),
        'minimum_quantity': value.minimumQuantity,
        'supplier_id': value.supplierId,
        'retailer_ids': value.retailerIds,
        'store_ids': value.storeIds,
        'product_category_id': value.productCategoryId,
        'product_list_id': value.productListId,
        'sku_ids': value.skuIds,
        'all_products': value.allProducts,
        'status': StatusToJSON(value.status),
        'created_at': (value.createdAt.toISOString()),
    };
}

